import React, { useEffect, useState } from "react";
import { Typography, Slider, Grid, Box } from '@mui/material';
import ModalFooter from "../../../Modal/ModalFooter/ModalFooter";

export default function StepFive(props) {
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': props.next,
                'text': 'Suivant',
                'disabled': true,
                'color': 'success'
            }
        ]);

    const marks = [
        {
            value: 0,
            label: 'Sans avis',
            p: 10
        },
        {
            value: 5,
            label: 'de temps en temps',
        },
        {
            value: 10,
            label: 'En majorité',
        }
    ];

    useEffect(() => {
        if (props.datas.profilRent && Object.keys(props.datas.profilRent).length >= 10) {
            buttons[1].disabled = false;
        } else {
            buttons[1].disabled = true;
        }
        setButtons([...buttons]);
    }, [props.datas]);

    function handleChange(e) {
        let datas = Object.assign({}, props.datas);
        if(!datas.profilRent){
            datas.profilRent = {};
        }
        datas.profilRent[e.target.name] = e.target.value;
        props.handleChange(datas);
    }

    return (
        <>
            <Typography id="modal-modal-description" variant="p">
                Selon vous, quelles sont les profils des consommateurs en « locations de logements à court et moyen terme» sur Montpellier et ses environs ?
            </Typography>
            <Grid container spacing={2} justifyContent='space-evenly' direction='row' className='borderTop'>
                <Grid item xs={12} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        Motif de séjour
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        Clientèle d’affaires
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.profilRent && props.datas.profilRent['businessCustomers'] ? props.datas.profilRent['businessCustomers'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='businessCustomers'
                                size='small'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={4} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        vacanciers
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.profilRent && props.datas.profilRent['vacationers'] ? props.datas.profilRent['vacationers'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='vacationers'
                                size='small'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={2} justifyContent='space-evenly' direction='row' className='borderTop'>
                <Grid item xs={12} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        Composition
                    </Typography>
                </Grid>
                <Grid item xs={12} md={5} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        Famille
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.profilRent && props.datas.profilRent['familly'] ? props.datas.profilRent['familly'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='familly'
                                size='small'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={5} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        groupe d'amis
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.profilRent && props.datas.profilRent['friends'] ? props.datas.profilRent['friends'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='friends'
                                size='small'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={5} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        Couples
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.profilRent && props.datas.profilRent['couple'] ? props.datas.profilRent['couple'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='couple'
                                size='small'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={5} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        Personnes seules
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.profilRent && props.datas.profilRent['alone'] ? props.datas.profilRent['alone'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='alone'
                                size='small'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={2} justifyContent='space-evenly' direction='row' className='borderTop'>
                <Grid item xs={12} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        Tranche d'âge
                    </Typography>
                </Grid>
                <Grid item xs={12} md={5} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        Moins de 25ans
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.profilRent && props.datas.profilRent['-25'] ? props.datas.profilRent['-25'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='-25'
                                size='small'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={5} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        25 - 30 ans
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.profilRent && props.datas.profilRent['25-30'] ? props.datas.profilRent['25-30'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='25-30'
                                size='small'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={5} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        30 - 50 ans
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.profilRent && props.datas.profilRent['30-50'] ? props.datas.profilRent['30-50'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='30-50'
                                size='small'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={5} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        Plus de 50 ans
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.profilRent && props.datas.profilRent['+50'] ? props.datas.profilRent['+50'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='+50'
                                size='small'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <ModalFooter buttons={buttons} />
        </>
    )
}